import classNames from 'classnames/bind';
import { StreamWidget as StreamWidgetType } from 'types/dashboard_widget';

import { useModal } from 'hooks/useModal';
import { useMqttStreamsState } from 'streams/hooks/useMqttStreamsState';
import { useStream } from 'streams/hooks/useStream';

import { Icon } from 'components/Icon/Icon';
import { VideoSourceSnapshot } from 'components/VideoSourceSnapshot/VideoSourceSnapshot';
import { WebRTCPlayer } from 'components/WebRTCPlayer/WebRTCPlayer';
import { Widget } from 'dashboards/widgets/Widget/Widget';

import styles from './StreamWidget.module.scss';

const c = classNames.bind(styles);

export function StreamWidget(widget: StreamWidgetType) {
  const { open } = useModal();

  const { data: stream } = useStream(widget.streamId);

  useMqttStreamsState([widget.streamId]);

  const isFileSearchEnabled =
    stream &&
    // We don't offer file search drawer for pipeline output streams because files are associated with the input stream
    stream.source !== 'pipeline_stream';

  return (
    <Widget
      widget={widget}
      menuItems={
        isFileSearchEnabled
          ? {
              search: {
                children: 'Search recordings',
                leftSection: <Icon name="search" size="small" />,
                onClick: () =>
                  open('files-search', { defaultStreamId: widget.streamId }),
              },
            }
          : undefined
      }
    >
      {widget.autoPlay ? (
        <WebRTCPlayer
          className={c('stream-player')}
          streamID={widget.streamId}
          auto
        />
      ) : (
        <VideoSourceSnapshot source={stream} compact hideTitle autoRefresh />
      )}
    </Widget>
  );
}
